import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import './logging/logging.css';
import FloatingSyncButton from '../components/FloatingSyncButton';
import StatsPeriodPicker, { presetPeriod } from '../components/adminstats/StatsPeriodPicker';
import StatsTabPanel from '../components/adminstats/StatsTabPanel';

/*
 * Admin → Statistieken.
 *
 * Every SoftTouch employee sees the Helpdesk tab; ADMIN / SUPER see the licence-wide tabs.
 * All tabs share one period + region picker and load on demand through adminStat&action=tab
 * (backend: auth/models/adminstats/StatsTabs.php, access: StatsAccess.php). The backend
 * decides what a user gets (per-employee helpdesk table only for SUPER, region lock for
 * regional employees); the frontend only mirrors that in what it shows.
 */

const HELPDESK_TAB = { key: 'helpdesk', label: 'Helpdesk' };
const ADMIN_TABS = [
  { key: 'overview', label: 'Overzicht' },
  { key: 'webshop', label: 'Webshop' },
  { key: 'mobile', label: 'MyFasMan Mobile' },
  { key: 'revenue', label: 'Revenue' },
  { key: 'api', label: 'API & integraties' },
  { key: 'peppol', label: 'Peppol' },
  { key: 'ai', label: 'AI & MCP' },
  { key: 'clients', label: 'Klanten & licenties' },
  { key: 'admin', label: 'Beheer & datakwaliteit' },
];

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return { id: `simple-tab-${index}`, 'aria-controls': `simple-tabpanel-${index}` };
}

const AdminStatScreen = (props) =>  {
    const isAdmin = props.group === "ADMIN" || props.group === "SUPER";
    // SoftTouch user type: 1 = both regions, 2 = Vlaanderen only, 3 = Wallonie only. The backend
    // enforces the same rule from sft_user_id; here it only decides what to show.
    const sftStatus = String(props.loginObj?.sft_status || '0');
    const lockedRegion = sftStatus === '2' ? 'VL' : sftStatus === '3' ? 'WA' : '';
    const tabs = isAdmin ? [HELPDESK_TAB, ...ADMIN_TABS] : [HELPDESK_TAB];

    const [period, setPeriod] = useState({ preset: '30d', region: lockedRegion, ...presetPeriod('30d') });
    const [reloadKey, setReloadKey] = useState(0);
    const [generatedAt, setGeneratedAt] = useState('');
    const [tabLoading, setTabLoading] = useState(false);
    const [value, setValue] = useState(0);

    useEffect(() => {
        props.changeScreen('logging');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const onTabLoaded = (data) => {
        setGeneratedAt(data && data.generated_at ? data.generated_at : '');
        setTabLoading(false);
    };

    const changePeriod = (next) => {
        setPeriod(next);
        if (next.from && next.to && next.from <= next.to) setTabLoading(true);
    };

  return (
    <div className={'_100perc log__main_container log__padding_sidebar'}>
        <FloatingSyncButton disabled={tabLoading} onClick={() => setReloadKey((k) => k + 1)} bottom={true}/>
        <div className={'log__container_content stats__card ' + props.theme + ' container_content_' + props.theme + ' box_fade-in'} >
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignContent: 'center', alignItems: 'center'}}>
                <div className={props.theme + " _100perc "}>
                    <div className="container_list__title align_left ">
                        <h2 className={props.theme} type="text" id="logging" name="logging">{props.t('admin')} - {props.t('statistics')}</h2>
                    </div>
                </div>
            </div>

        <Box className={props.theme + ' licence__enivronment'}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className={props.theme + ' container_tabs_below_subtitle'}>
              <Tabs value={value} onChange={handleChange} className={props.theme} variant="scrollable" scrollButtons="auto">
                {tabs.map((tab, i) => <Tab key={tab.key} label={tab.label + " "} {...a11yProps(i)} className={props.theme}/>)}
              </Tabs>
          </Box>

          {tabs.map((tab, i) => (
            <TabPanel key={tab.key} value={value} index={i}>
              <StatsPeriodPicker value={period} onChange={changePeriod} disabled={tabLoading} t={props.t} generatedAt={generatedAt} lockedRegion={lockedRegion} />
              <StatsTabPanel tab={tab.key} period={period} group={props.group} userId={props.userId} theme={props.theme} t={props.t} reloadKey={reloadKey} onLoaded={onTabLoaded} />
            </TabPanel>
          ))}

      </Box>
        </div>
    </div>
  );
}

export default AdminStatScreen;
